import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withKeys as _withKeys, normalizeClass as _normalizeClass, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bc71a6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "monitor" }
const _hoisted_2 = { class: "mod_c monitor_player" }
const _hoisted_3 = { class: "mod_c_title" }
const _hoisted_4 = { class: "mod_c_tbody" }
const _hoisted_5 = { class: "monitor_player_nav" }
const _hoisted_6 = { class: "video_play" }
const _hoisted_7 = { class: "video_play" }
const _hoisted_8 = { class: "mod_c monitor_list" }
const _hoisted_9 = { class: "mod_c_title" }
const _hoisted_10 = { class: "list_view" }
const _hoisted_11 = { class: "list_box" }
const _hoisted_12 = {
  key: 1,
  class: "list_work"
}
const _hoisted_13 = { class: "list_work_action" }
const _hoisted_14 = {
  key: 0,
  class: "item_mask"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "item_btn" }
const _hoisted_17 = { class: "item_content_img" }
const _hoisted_18 = { class: "msak_time" }
const _hoisted_19 = { class: "item_content_right" }
const _hoisted_20 = ["onDblclick"]
const _hoisted_21 = { class: "item_content_right_txt" }
const _hoisted_22 = ["onDblclick"]
const _hoisted_23 = { class: "item_move" }
const _hoisted_24 = { class: "list_set" }
const _hoisted_25 = { class: "list_set_left" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = { class: "updata" }
const _hoisted_28 = { class: "updata_set" }
const _hoisted_29 = { class: "updata_set_left" }
const _hoisted_30 = { class: "monitor_player_control" }
const _hoisted_31 = { class: "control_time" }
const _hoisted_32 = { class: "control_play" }
const _hoisted_33 = { class: "control_info" }
const _hoisted_34 = { class: "updata_set_right" }
const _hoisted_35 = {
  class: "time_line",
  id: "time_black"
}
const _hoisted_36 = { class: "video_info" }
const _hoisted_37 = { class: "video_title" }
const _hoisted_38 = { class: "video_title" }
const _hoisted_39 = ["onMousedown"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tail" }, null, -1))
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "manage_s" }, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "manage_c" }, null, -1))
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "是否离开页面？", -1))

import { computed, onMounted, onUnmounted, reactive, ref, watch, watchEffect, nextTick, inject } from 'vue';
import { Switch, Dropdown, Menu, Modal, Empty, message, Tooltip, TimePicker } from 'ant-design-vue';
import { useRouter, useRoute } from 'vue-router';
import 'video.js/dist/video-js.css';
import { VueDraggableNext } from 'vue-draggable-next';
import { dragDrop } from '@/utils/format/dragDrop';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import { onBeforeRouteLeave } from 'vue-router';
import {
  RollbackOutlined,
  StepBackwardOutlined,
  CaretRightOutlined,
  StepForwardOutlined,
  PauseOutlined,
} from '@ant-design/icons-vue';
import {
  useTimeLine,
  gridBufferList,
  timeLine_width,
  timescale_width,
  second2hms,
  hmsSecond,
  addVideoOnCurrentSection,
  clearVideoOfCurrentSection,
  gridTime,
  dataURItoBlob,
  minFrameWidth,
  maxFrameOfMaterial,
  frameWidth,
  gridFrame,
  zoomOut,
  zoomIn,
  zoomFit,
} from './components/timeLine';
import CUpload from '@/components/CUpload.vue';
import { FileInfo } from './components/type';
import Grid from './components/Grid.vue';
import VideoItem from './components/VideoItem.vue';
import http from '@/api/videoDot';
import axios from '@/api';
import video_editor_empty from '@/assets/svg/video_editor_empty.svg';
import CDelModal from '@/components/CDelModal.vue';
import { useHomeStore } from '@/pinia/home';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoEditor',
  setup(__props) {

const draggable = VueDraggableNext;
const aSwitch = Switch;
const aDropdown = Dropdown;
const aMenu = Menu;
const aMenuItem = Menu.Item;
const aTooltip = Tooltip;
const aTimePicker = TimePicker;
const aModal = Modal;

const aEmpty = Empty;
const router = useRouter();
const route = useRoute();
const homeStore = useHomeStore();

const form = ref({
  showForward: false,
  showDownload: true,
  showDate: true,
  showCover: true,
  showOrder: true,
  showNum: true,
  opacity: 30,
});
const timeValue = ref();

const videoRef = ref();
const currentVideoUrl = ref();

const videoPlayer = ref(); //播放器实例
const currentTime = ref('00:00:00'); //当前播放器时间
const duration = ref(route.query.duration); // 播放器时chang
const paused = ref(false); //播放器是否播放

const videoJsCreate = () => {
  videoPlayer.value = new window.videojs(videoRef.value, {
    language: 'zh-CN',
    notSupportedMessage: '此视频暂时无法播放,请稍后再试',
    controls: false,
    techOrder: ['html5'], //html5模式和flvjs模式
    fluid: true, //流式布局,适应父元素大小
    aspectRatio: '16:9', //流式布局时，自适应大小的比例
    // flvjs: {
    //   mediaDataSource: {
    //     isLive: true, //是否是直播
    //     cors: true, //是否跨域
    //     withCredentials: false, //是否跨站检测
    //   },
    // },
    bigPlayButton: false,
    poster: route.query.cover_url, //海报
    preload: true, //预加载
    autoplay: false, //是否自动播放
  });
  videoPlayer2.value = new window.videojs(videoRef2.value, {
    language: 'zh-CN',
    notSupportedMessage: '此视频暂时无法播放,请稍后再试',
    controls: false,
    techOrder: ['html5'], //html5模式和flvjs模式
    fluid: true, //流式布局,适应父元素大小
    aspectRatio: '16:9', //流式布局时，自适应大小的比例
    bigPlayButton: false,
    preload: true, //预加载
    autoplay: false, //是否自动播放
  });
};

const videojsPlay = () => {
  videoPlayer.value.src({
    src: currentVideoUrl.value,
  });
  videoPlayer2.value.src({
    src: currentVideoUrl.value,
  });
};
const gridWidth = ref(); //帧图片宽度

const loadVideojs: any = inject('loadVideojs');

onMounted(async () => {
  if (!homeStore.onVideojs) {
    await loadVideojs();
    homeStore.onVideojs = true;
  }

  if (route.query.video_url) {
    currentVideoUrl.value = route.query.video_url;
    videoJsCreate();

    const title = route.query.title as string;
    const type = `video/${route.query.format}`;
    const resSize = route.query.size as string;
    const sizeType = resSize.substring(resSize.length - 2);
    const sizeValue = Number(resSize.slice(0, resSize.length - 2));
    const size = sizeType === 'GB' ? sizeValue * 1073741824 : sizeType === 'MB' ? sizeValue * 1048576 : sizeValue * 1024;
    const formData = new File([route.query.video_url as string], title, { type: type });

    Object.defineProperty(formData, 'size', {
      value: Math.trunc(size),
      writable: true,
      configurable: true,
      enumerable: true,
    });
    clickAddVideo(formData);
    videojsPlay();

    videoPlayer.value.on('timeupdate', function () {
      currentTime.value = second2hms(videoPlayer.value.currentTime());
      if (videoPlayer.value.currentTime() === videoPlayer.value.duration()) {
        paused.value = false;
      }
      if (!videoRef.value.paused) {
        frameUpdata();
      }
    });
    getGridWith();
  }
});

// 视频帧随视频播放滑动
const frameUpdata = () => {
  const dom: any = document.getElementById('move_icon');
  let left = (videoPlayer.value.currentTime() / hmsSecond(gridTime.value.value)) * 10 + 10;

  const clientWidth = Number(gridWidth.value) + 10;
  if (left > clientWidth - dom.offsetWidth) {
    left = clientWidth - dom.offsetWidth;
  }
  dom.style.left = left + 'px';
  dom.style.transition = 'left 0.3s';
  move.objX = left;
};

// 根据视频长度获取视频轨道图片渲染的宽度
const getGridWith = () => {
  const time = computed(() => hmsSecond(route.query.duration));
  const time1 = computed(() => hmsSecond(gridTime.value.value));
  gridWidth.value = ((time.value / time1.value) * 10).toFixed(2);
};
// 根据视频长度获取每隔多久获取一帧图片
const getFrameUrl = computed(() => {
  const duration = computed(() => hmsSecond(route.query.duration));
  const num = computed(() => Math.ceil(gridWidth.value / 124));
  const width = computed(() => duration.value / num.value);
  return width;
});

const isforchange = ref(true);
watch(
  () => frameWidth.value,
  () => {
    const length = computed(() => Math.ceil(gridWidth.value / 124));
    if ((gridTime.value.value !== '00:03:00' && isforchange.value) || (frameWidth.value != 0.003 && isforchange.value)) {
      nextTick(() => {
        viderUrlList.value = [];
        currentTimeUrl.value = 1;
        forchange(length.value);
        isforchange.value = false;
      });
    }
  }
);

const disDot = computed(() => {
  if (imgNums.value === 0) {
    return true;
  } else {
    return false;
  }
}); //是否禁用打点
const viderUrlList = ref<any>([]);
const videoPlayer2 = ref(); //播放器实例
const videoRef2 = ref();
const currentTimeUrl = ref(1);
// 获取视频本地图片
const getViderUrl = ref(false);
const currentTimeList = ref<any>([]);
const imgNum = ref(0);
const imgNums = ref(0);
const video = ref();
const timeListener = ref(true);
const forchange = (num: any) => {
  imgNums.value = 0;
  imgNum.value = num + 1;
  currentTimeList.value = [];
  getViderUrl.value = true;
  const zreo = ref(0);
  video.value = videoRef2.value;
  video.value.setAttribute('crossorigin', 'anonymous'); //处理跨域
  video.value.setAttribute('preload', 'auto');
  for (let i = 0; i < imgNum.value; i++) {
    const time = i === 0 ? zreo : getFrameUrl.value;
    currentTimeUrl.value = currentTimeUrl.value + time.value;
    currentTimeList.value.push(currentTimeUrl.value);
  }
  video.value.currentTime = currentTimeList.value[0];
  if (timeListener.value) {
    timeListener.value = false;
    timeupdate();
  }
};

const disForward = ref(false);
// 监听视频时长变化
const timeupdate = () => {
  video.value.addEventListener('timeupdate', () => {
    if (imgNum.value == imgNums.value + 1) {
      imgNums.value = 0;
      getViderUrl.value = false;
    }
    const canvas = document.createElement('canvas');
    const width = video.value.width || 124; //canvas的尺寸和图片一样
    const height = video.value.height || 70;
    canvas.width = width;
    canvas.height = height;
    canvas.getContext('2d')?.drawImage(video.value, 0, 0, width, height); //绘制canvas
    const blob = dataURItoBlob(canvas.toDataURL('image/jpg'));
    const position = `${imgNums.value * 124 + 'px'} 0px`;
    if (getViderUrl.value || showVideoUrl.value) {
      imgNums.value++;
      viderUrlList.value.push({
        url: URL.createObjectURL(blob),
        position: position,
        blob: blob,
      });
      imgNums.value == currentTimeList.value.length ? '' : (video.value.currentTime = currentTimeList.value[imgNums.value]);
      if (imgNum.value == imgNums.value + 1) {
        showVideoUrl.value = false;
      }
    }
    if (!getViderUrl.value) {
      vedioDotList.value.some((res: any) => {
        if (second2hms(video.value.currentTime) == res.start_frame) {
          res.node_cover_url = URL.createObjectURL(blob);
          res.blob = blob;
        }
      });
      if (disForward.value && vedioDotList.value.length > 0) {
        const dotList = JSON.parse(JSON.stringify(vedioDotList.value));
        dotList.forEach((e: any, index: number) => {
          e.blob = vedioDotList.value[index].blob;
        });
        forwardList.value.push([...dotList]);
      }
    }
  });
};

// 播放视频
const clickPlay = () => {
  // 0 暂停 1播放
  paused.value = videoRef.value.paused;
  videoRef.value.paused ? videoPlayer.value.play() : videoPlayer.value.pause();
};
// 全屏
const clickFullScreen = () => {
  if (videoPlayer.value.controlBar.fullscreenToggle) {
    videoPlayer.value.requestFullscreen();
    videoPlayer.value.isFullscreen(true);
  } else {
    videoPlayer.value.exitFullscreen();
    videoPlayer.value.isFullscreen(false);
  }
};
// 快进  后退
const clickSchedule = (val: number) => {
  val
    ? videoPlayer.value.currentTime(videoPlayer.value.currentTime() + 1)
    : videoPlayer.value.currentTime(videoPlayer.value.currentTime() - 1);
  currentTime.value = second2hms(videoPlayer.value.currentTime());
  frameUpdata();
};
const visible = ref(false);

const dragOptions = ref({
  animation: 200,
  group: 'description',
  disabled: false,
  ghostClass: 'ghost',
});

// 初始化：时间轴组件的宽度
const editorRef = ref();
const refWidth = ref(0);
const timeLineContainer_width = ref(0);
onMounted(() => {
  timeLineContainer_width.value = editorRef.value?.offsetWidth;
  refWidth.value = editorRef.value?.offsetWidth;
  useTimeLine(timeLineContainer_width.value, duration.value);
  setTimeout(() => {
    move.show = true;
  }, 1000);
});

// 动态监听：窗口变化 -> 时间轴组件的宽度
window.onresize = () =>
  (() => {
    timeLineContainer_width.value = editorRef.value?.offsetWidth;
    refWidth.value = editorRef.value?.offsetWidth;
  })();

watchEffect(() => {
  useTimeLine(timeLineContainer_width.value, duration.value);
  getGridWith();
});

const currentFile = ref();
// 视频上传 Callback
const clickAddVideo = (files: any) => {
  addVideoOnCurrentSection(files, currentVideoUrl.value, videoRef.value);
  currentFile.value = files;
};

const move = reactive({
  currentX: 0,
  currentY: 0,
  objX: 10,
  objY: 0,
  show: false,
});
// 进度帧拖动事件
const timeDragMove = (e: any) => {
  const dom: any = document.getElementById('move_icon');
  move.currentX = e.clientX - dom.offsetLeft; //鼠标的x坐标减去dom的左边距离，currentX这个距离是不会变的，通过这个新鼠标的X坐标减去currentX就是dom的Left
  move.currentY = e.clientY - dom.offsetTop;
  document.onmousemove = function (ev) {
    ev.preventDefault();
    //为了防止鼠标移动太快而离开了DIV产生了bug，所以要给整个页面加onmousemove事件
    move.objX = ev.clientX - move.currentX;
    move.objY = ev.clientY - move.currentY;
    //优化部分：鼠标移动到浏览器左侧、右侧、上侧、下侧时的问题
    const clientWidth = Number(gridWidth.value) + 10;
    if (move.objX < 0) {
      move.objX = 10;
    } else if (move.objX > clientWidth - dom.offsetWidth) {
      move.objX = clientWidth - dom.offsetWidth;
    }
    dom.style.left = move.objX + 'px';
    dom.style.transition = 'none';

    const resCurrentTime = ((move.objX - 10) / 10) * hmsSecond(gridTime.value.value);
    currentTime.value = second2hms(resCurrentTime);
    videoPlayer.value.currentTime(resCurrentTime);
  };
  document.onmouseup = function () {
    //鼠标松开时
    document.onmousemove = null; //把鼠标移动清除
    document.onmouseup = null; //把鼠标松开清除
  };
};
// 进度帧点击事件

const clickObjX = ref(209);
const clickUpdataTime = (event: any) => {
  const dom: any = document.getElementById('move_icon');
  const scroll: any = document.getElementById('time_black');
  let width = event.clientX - clickObjX.value;

  const clientWidth = Number(gridWidth.value) + 10;
  if (width < 10) {
    width = 10;
  } else if (width > clientWidth - dom.offsetWidth) {
    width = clientWidth - dom.offsetWidth;
  }

  move.objX = width + scroll.scrollLeft;
  dom.style.left = move.objX + 'px';

  dom.style.transition = 'none';
  const resCurrentTime = ((move.objX - 10) / 10) * hmsSecond(gridTime.value.value);
  currentTime.value = second2hms(resCurrentTime);
  videoPlayer.value.currentTime(resCurrentTime);
};

const showVideoUrl = ref(false);

// 放大 缩小 时间轴
const clickZoomChange = (type: number) => {
  if (type === 1) {
    zoomOut(); //缩小
  } else if (type === 2) {
    zoomIn(); //放大
  } else {
    zoomFit(); //平铺
  }
  nextTick(() => {
    const length = computed(() => Math.ceil(gridWidth.value / 124));
    showVideoUrl.value = true;
    viderUrlList.value = [];
    currentTimeUrl.value = 1;
    currentTimeList.value = [];
    forchange(length.value);
    getPositionArr();
  });
};

// 打点帧
const positionArr = ref<any>([]); //帧列表
let belong: any; //打点所在区域的index
const posContinue = ref(true);
const videoManage = () => {
  posContinue.value = true;
  backList.value = [];
  positionArr.value.some((e: any) => {
    if (e === move.objX || getTime(e, 10) === getTime(move.objX, 10)) {
      console.log('重复了');
      posContinue.value = false;
    }
  });
  if (!posContinue.value) {
    message.destroy();
    message.error('不能在同一时间重复打点！');
    return;
  } else {
    positionArr.value.push(move.objX);
    const Arr = positionArr.value.sort(function (a: number, b: number) {
      return a - b;
    });
    const index = Arr.indexOf(move.objX);
    const a = index == 0 ? '00:00:00' : getTime(Arr[index - 1], 10); //打点帧的前一个时间
    const b = getTime(Arr[index], 10); //打点帧的时间
    const c = index == Arr.length - 1 ? duration.value : getTime(Arr[index + 1], 10); //打点帧的后一个时间
    if (vedioDotList.value.length > 0) {
      vedioDotList.value.some((res: any, index: number) => {
        if (res.start_frame == a && res.end_frame == c) {
          belong = index;
          return true;
        }
      });
    } else {
      addDotList(a, b);
    }
    addDotList(b, c);
  }
};
// 帧位置转时间
const getTime = (time: number, deviation: number) => {
  return second2hms(((time - deviation) / 10) * hmsSecond(gridTime.value.value));
};
// 打点自动生成列表
const addDotList = (start: any, end: any) => {
  const timeData = new Date();
  let data = {
    id: 0,
    node_title: '片段' + (vedioDotList.value.length + 1),
    start_frame: start,
    end_frame: end,
    speaker: '',
    node_cover_url: '',
    created_at: timeData.toLocaleDateString(),
    updataTitle: false,
    updataSpeaker: false,
    jump_over: 0,
  };
  if (belong !== undefined) {
    vedioDotList.value[belong].end_frame = start;
    if (vedioDotListL.value > 0) {
      data = { ...vedioDotList.value[belong] };
      data.start_frame = start;
      data.end_frame = end;
      data.node_title = '片段' + (vedioDotList.value.length + 1);
      data.created_at = timeData.toLocaleDateString();
      data.updataTitle = false;
      data.updataSpeaker = false;
      data.jump_over = 0;
      data.id = 0;
      vedioDotList.value.splice(belong + 1, 0, data);
    } else {
      vedioDotList.value.splice(belong + 1, 0, data);
      vedioDotList.value.map((res: any, index: number) => {
        if (res.node_title.indexOf('片段') !== -1) {
          res.node_title = `片段${index + 1}`;
        }
      });
    }
  } else {
    vedioDotList.value.push(data);
  }
  vedioDotList.value.forEach((e: any, index: number) => {
    e.order_by = index;
    if (e.node_title.substring(0, 2) === '片段' && e.node_title.substring(2).match(/[0-9]/gi)) {
      e.node_title = `片段${index + 1}`;
    }
  });
  getStartImg(start);
};
// 获取帧图片
const getStartImg = (start: any) => {
  if (hmsSecond(start) == 0) {
    vedioDotList.value.some((res: any) => {
      if (res.start_frame == '00:00:00') {
        res.node_cover_url = viderUrlList.value[0].url;
        res.blob = viderUrlList.value[0].blob;
      }
    });
  } else {
    disForward.value = true;
    videoRef2.value.currentTime = hmsSecond(start);
  }
};

const video_id = route.query.video_id;

// 保存
const saveDotList = useDebounce(async () => {
  let arr: any = [];
  for (const e of vedioDotList.value) {
    if (e.node_cover_url.indexOf('blob') != -1) {
      e.file = new window.File([e.blob], e.node_title, { type: 'image/jpg' });
      e.formData = new FormData();
      e.formData.append('images', e.file as any);
      const res = await axios.liveExpress.upImages(e.formData);
      e.node_cover_url = res.data.data.url;
    }
  }
  vedioDotList.value.forEach((e: any) => {
    arr.push({
      id: e.id || 0,
      node_title: e.node_title,
      speaker: e.speaker,
      node_cover_url: e.node_cover_url,
      start_frame: hmsSecond(e.start_frame),
      end_frame: hmsSecond(e.end_frame),
      order_by: e.order_by,
      jump_over: e.jump_over,
    });
  });
  const data = { video_id: video_id, content: JSON.stringify(arr) };
  http
    .addVideoDotting(data)
    .then((res) => {
      message.success(res.data.message);
      getVedioDotList();
    })
    .catch((err) => message.error(err.data.error));
});

// 获取打点视频列表
const vedioDotList = ref<any>([]);
const vedioDotListL = ref(0);
const needReset = ref(true);
const apiList = ref<any>([]); //接口获取的初始数据
const getVedioDotList = () => {
  http.getDottingList({ params: { video_id } }).then((res) => {
    vedioDotList.value = [...res.data.data];
    apiList.value = res.data.data;
    vedioDotList.value.map((res: any, index: number) => {
      res.updataTitle = false;
      res.updataSpeaker = false;
      //是否需要重排顺序
      if (needReset.value && index < vedioDotList.value.length - 1) {
        needReset.value = !(hmsSecond(res.start_frame) > hmsSecond(vedioDotList.value[index + 1].start_frame));
      }
    });
    setTimeout(() => {
      getPositionArr();
    }, 1000);
    vedioDotListL.value = vedioDotList.value.length;
  });
};
getVedioDotList();
// 视频列表显示打点
const getPositionArr = () => {
  showclickFrame.value = {};
  clickFrame.value = null;
  positionArr.value = [];
  vedioDotList.value.map((res: any) => {
    let start_frame = (hmsSecond(res.start_frame) / hmsSecond(gridTime.value.value)) * 10 + 10;
    let end_frame = (hmsSecond(res.end_frame) / hmsSecond(gridTime.value.value)) * 10 + 10;
    if (positionArr.value.indexOf(start_frame) == -1 && res.start_frame !== '00:00:00') {
      positionArr.value.push(start_frame);
    }
    if (positionArr.value.indexOf(end_frame) == -1 && res.end_frame !== duration.value) {
      positionArr.value.push(end_frame);
    }
  });
};

// 获取视频打点配置
const getDotConfig = () => {
  http.getDottingConfigInfo({ params: { video_id } }).then((res) => {
    const resData = res.data.data;
    form.value.showForward = Boolean(resData.is_fast_forward);
    form.value.showCover = Boolean(resData.is_show_cover);
    form.value.showDate = Boolean(resData.is_show_date);
    form.value.showOrder = Boolean(resData.is_show_number);
    form.value.showNum = Boolean(resData.is_show_views);
    form.value.showDownload = Boolean(resData.is_download);
  });
};
getDotConfig();

// 设置视频打点配置
const modifyConfig = () => {
  let data = {
    video_id,
    is_fast_forward: Number(form.value.showForward),
    is_show_cover: Number(form.value.showCover),
    is_show_date: Number(form.value.showDate),
    is_show_number: Number(form.value.showOrder),
    is_show_views: Number(form.value.showNum),
    is_download: Number(form.value.showDownload),
  };
  http.setDottingConfig(data).then((res) => {
    console.log(res.data.message);
  });
};

// 清空打点
const delVisible = ref(false);
const clearListData = () => {
  vedioDotList.value = [];
  positionArr.value = [];
};
const emptyDot = () => {
  if (!delVisible.value) {
    delVisible.value = true;
  } else {
    let ids: any[] = [];
    vedioDotList.value.forEach((e: any) => {
      e?.id != 0 ? ids.push(e) : clearListData();
    });
    if (ids && ids.length != 0) {
      http
        .clearDottingList({ params: { video_id } })
        .then(() => clearListData())
        .catch((err) => message.success(err.data.error));
    }
    delVisible.value = false;
    message.success('清空成功！');
  }
};

// 打点列表双击修改
const editorDotting = (type: number, item: any) => {
  switch (type) {
    case 1:
      item.updataTitle = true;
      break;
    case 2:
      item.updataSpeaker = true;
      break;
  }
};
const updataDotting = (type: number, item: any) => {
  switch (type) {
    case 1:
      if (item.node_title === '') {
        message.error('主标题不能为空！');
      } else {
        item.updataTitle = false;
      }
      break;
    case 2:
      item.updataSpeaker = false;
      break;
  }
};
const handleChanget = (info: FileInfo, item: any) => {
  if (info.file.response.code === 100) {
    message.error(info.file.response.error);
  }
  if (info.file?.response?.code === 200) {
    item.node_cover_url = info.file?.response?.data.url;
  }
};
const clickStop = (info: FileInfo, item: any) => {
  item.node_cover_url = '';
};

const forwardList = ref<any>([]); //退一步列表
const backList = ref<any>([]); //进一步列表

// 后退打点
const onUndo = () => {
  if (forwardList.value.length > 0) {
    backList.value.push(forwardList.value[forwardList.value.length - 1]);
    forwardList.value.pop();
    vedioDotList.value = forwardList.value[forwardList.value.length - 1] || apiList.value || [];
    getPositionArr();
  }
};

//前进打点
const onBack = () => {
  if (backList.value.length > 0) {
    forwardList.value.push(backList.value[backList.value.length - 1]);
    vedioDotList.value = backList.value[backList.value.length - 1];
    backList.value.pop();
    getPositionArr();
  }
};

// 选择帧
const clickFrame = ref();
const showclickFrame = ref({});
const clickManage = (time: any) => {
  clickFrame.value = getTime(time, 10);
  positionArr.value.forEach((e: number) => {
    showclickFrame.value[e] = false;
  });
  showclickFrame.value[time] = true;
};

const frameVideoRef = ref();
const frameManageRef = ref();
const clearManage = (e: MouseEvent) => {
  if (frameManageRef.value && frameManageRef.value.contains(e.target)) {
    showclickFrame.value = {};
    clickFrame.value = null;
  }
};
onMounted(() => {
  frameVideoRef.value.addEventListener('click', clearManage);
});
onUnmounted(() => {
  frameVideoRef.value.removeEventListener('click', clearManage);
});

// 删除帧
const deleteFrame = () => {
  let startIndex: any;
  let endIndex: any;
  vedioDotList.value.map((res: any, index: number) => {
    res.end_frame == clickFrame.value ? (startIndex = index) : '';
    res.start_frame == clickFrame.value ? (endIndex = index) : '';
  });
  vedioDotList.value[startIndex].end_frame = vedioDotList.value[endIndex].end_frame;
  vedioDotList.value.splice(endIndex, 1);
  if (
    vedioDotList.value.length == 1 &&
    vedioDotList.value[0].start_frame == '00:00:00' &&
    vedioDotList.value[0].end_frame == duration.value
  ) {
    vedioDotList.value = [];
  }
  getPositionArr();
  const dotList = JSON.parse(JSON.stringify(vedioDotList.value));
  forwardList.value.push([...dotList]);
};

// 打点列表修改视频时间
const clickVideoUpdata = (item: any) => {
  videoPlayer.value.currentTime(hmsSecond(item.start_frame));
};

// 视频轨道修改视频时间
const updataVideoTime = () => {
  if (hmsSecond(timeValue.value) > videoPlayer.value.duration()) {
    message.info('不能超过当前视频时长！');
    timeValue.value = undefined;
  } else {
    videoPlayer.value.currentTime(hmsSecond(timeValue.value));

    const dom: any = document.getElementById('move_icon');
    const scroll: any = document.getElementById('time_black');
    const left = (hmsSecond(timeValue.value) / hmsSecond(gridTime.value.value)) * 10 + 10;
    move.objX = left + scroll.scrollLeft;
    dom.style.left = move.objX + 'px';
  }
};

// 快捷键方法
const isMac = (() => {
  return /macintosh|mac os x/i.test(navigator.userAgent);
})();
const onKeyDown = (event: any) => {
  let a = event.keyCode;
  if (a === 32) {
    event.preventDefault();
    clickPlay(); //视频暂停播放
  }
  if (a === 37) {
    event.preventDefault();
    clickSchedule(0); //后退1s
  }
  if (a === 39) {
    event.preventDefault();
    clickSchedule(1); // 快进1s
  }
  if (a === 122) {
    event.preventDefault();
    clickFullScreen(); //全屏
  }
  if (!isMac && event.ctrlKey && a === 90 && forwardList.value.length !== 0) {
    onUndo(); //撤回
  }
  if (!isMac && event.ctrlKey && a === 89 && backList.value.length !== 0) {
    onBack(); //恢复
  }
  if (isMac && event.metaKey && a === 90 && forwardList.value.length !== 0) {
    onUndo(); //撤回
  }
  if (isMac && event.metaKey && a === 89 && backList.value.length !== 0) {
    onBack(); //恢复
  }
  if (a === 68 && disDot.value) {
    videoManage(); //打点
  }
  if (a === 46 && clickFrame.value) {
    deleteFrame(); // 删除打点
  }
  if (a === 187 && gridWidth.value < maxVideoUrlWidth.value) {
    clickZoomChange(2); //放大时间轴
  }
  if (a === 189 && maxFrameOfMaterial.value !== 0 && frameWidth.value !== minFrameWidth.value) {
    clickZoomChange(1); // 缩小时间轴
  }
  if (a === 82) {
    clickZoomChange(3); // 恢复时间轴
  }
};
document.onkeydown = onKeyDown;

// 离开页面提示
// const url = window.location.href;
const toName = ref();
const toTip = ref(false);
const modalLeave = ref(false);
// 返回媒体库
const cancel = () => {
  router.push('/media/videos');
};

onBeforeRouteLeave((to, from) => {
  if (!toTip.value && vedioDotList.value.length > 0) {
    toName.value = to.name;
    modalLeave.value = toTip.value = true;
    return from.fullPath;
  }
});

// 离开
const leaveView = () => {
  modalLeave.value = false;
  router.push({
    name: toName.value,
  });
};
// 不离开
const noLeaveView = () => {
  modalLeave.value = toTip.value = false;
};

// 是否跳过
const jumpOverDotting = (item: any, jump: number) => {
  item.jump_over = jump;
};

// 销毁
onUnmounted(() => {
  clearVideoOfCurrentSection();
  videoPlayer.value.dispose();
  gridTime.value.value = 0;
  gridFrame.value = 0;
  frameWidth.value = 0.003;
});

const changeDrag = () => {
  vedioDotList.value.forEach((e: any, i: number) => {
    e.order_by = i;
  });
};

// 视频轨道最大宽度
const maxVideoUrlWidth = computed(() => hmsSecond(duration.value) * 10);

watch(
  () => homeStore.collapsed,
  () => {
    if (homeStore.collapsed) {
      timeLineContainer_width.value = refWidth.value + 126;
      clickObjX.value = 83;
    } else {
      clickObjX.value = 209;
      setTimeout(() => {
        timeLineContainer_width.value = refWidth.value;
      }, 200);
    }
  }
);

const isFullScreen = ref(false);
const openFullScreen = () => {
  isFullScreen.value = !isFullScreen.value;
  if (isFullScreen.value) {
    clickObjX.value = 19;
    timeLineContainer_width.value = refWidth.value + 190;
  } else {
    if (homeStore.collapsed) {
      timeLineContainer_width.value = refWidth.value + 126;
      clickObjX.value = 83;
    } else {
      clickObjX.value = 209;
      timeLineContainer_width.value = refWidth.value;
    }
  }
  homeStore.isFullScreen = isFullScreen.value;
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "editorRef",
    ref: editorRef,
    class: "editor"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, "播放器 " + _toDisplayString(gridWidth.value) + " " + _toDisplayString(isFullScreen.value), 1),
          _createVNode(_component_a_button, {
            onClick: cancel,
            class: "black_btn"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(RollbackOutlined)),
              _createTextVNode("视频库 ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              _createElementVNode("video", {
                ref_key: "videoRef",
                ref: videoRef,
                id: "videojs-player",
                controls: "",
                class: "video-js vjs-matrix vjs-default-skin vjs-big-play-centered"
              }, null, 512)
            ], 512), [
              [_vShow, videoPlayer.value]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_7, [
              _createElementVNode("video", {
                ref_key: "videoRef2",
                ref: videoRef2,
                id: "videojs-player",
                controls: "",
                class: "video-js vjs-matrix vjs-default-skin vjs-big-play-centered"
              }, null, 512)
            ], 512), [
              [_vShow, false]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createTextVNode(" 打点片段 (" + _toDisplayString(vedioDotList.value.length) + ") ", 1),
          _createVNode(_component_a_button, {
            onClick: _unref(saveDotList),
            class: "black_btn"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 保存 ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (vedioDotList.value.length === 0)
              ? (_openBlock(), _createBlock(_unref(aEmpty), {
                  key: 0,
                  class: "empty_wrap",
                  image: _unref(video_editor_empty),
                  description: "暂无打点片段哦~"
                }, null, 8, ["image"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_unref(draggable), _mergeProps({
                      handle: ".mover",
                      list: vedioDotList.value
                    }, dragOptions.value, {
                      onDrop: _unref(dragDrop),
                      onChange: changeDrag
                    }), {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vedioDotList.value, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["list_item", { list_item_hover: !item.jump_over }]),
                            key: item.id
                          }, [
                            (item.jump_over)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              class: "item_content",
                              onClick: ($event: any) => (clickVideoUpdata(item))
                            }, [
                              _createElementVNode("div", _hoisted_16, [
                                (!item.jump_over)
                                  ? (_openBlock(), _createBlock(_component_a_button, {
                                      key: 0,
                                      class: "item_btn_del",
                                      onClick: ($event: any) => (jumpOverDotting(item, 1))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" 屏蔽")
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : (_openBlock(), _createBlock(_component_a_button, {
                                      key: 1,
                                      class: "item_btn_reh",
                                      onClick: ($event: any) => (jumpOverDotting(item, 0))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" 恢复")
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                              ]),
                              _createElementVNode("div", _hoisted_17, [
                                _createVNode(CUpload, {
                                  "file-list": item.fileList,
                                  "handle-change": (info) => handleChanget(info, item),
                                  "image-name": item.node_cover_url,
                                  "click-stop": (info) => clickStop(info, item),
                                  class: "upload"
                                }, null, 8, ["file-list", "handle-change", "image-name", "click-stop"]),
                                _createElementVNode("div", _hoisted_18, _toDisplayString(item.start_frame) + " - " + _toDisplayString(item.end_frame), 1)
                              ]),
                              _createElementVNode("div", _hoisted_19, [
                                (!item.updataTitle)
                                  ? (_openBlock(), _createBlock(_unref(aTooltip), {
                                      key: 0,
                                      placement: "topLeft"
                                    }, {
                                      title: _withCtx(() => [
                                        _createTextVNode(" 双击修改主标题 ")
                                      ]),
                                      default: _withCtx(() => [
                                        _createElementVNode("p", {
                                          onDblclick: ($event: any) => (editorDotting(1, item))
                                        }, _toDisplayString(item.node_title), 41, _hoisted_20)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (_openBlock(), _createBlock(_component_a_input, {
                                      key: 1,
                                      value: item.node_title,
                                      "onUpdate:value": ($event: any) => ((item.node_title) = $event),
                                      onKeydown: _withKeys(($event: any) => (updataDotting(1, item)), ["enter"]),
                                      onBlur: ($event: any) => (updataDotting(1, item)),
                                      size: "small",
                                      style: {"width":"70%"}
                                    }, null, 8, ["value", "onUpdate:value", "onKeydown", "onBlur"])),
                                _createElementVNode("div", _hoisted_21, [
                                  (!item.updataSpeaker)
                                    ? (_openBlock(), _createBlock(_unref(aTooltip), {
                                        key: 0,
                                        placement: "topLeft"
                                      }, {
                                        title: _withCtx(() => [
                                          _createTextVNode(" 双击修改副标题 ")
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("span", {
                                            onDblclick: ($event: any) => (editorDotting(2, item))
                                          }, _toDisplayString(item.speaker ? item.speaker : '副标题'), 41, _hoisted_22)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : (_openBlock(), _createBlock(_component_a_input, {
                                        key: 1,
                                        value: item.speaker,
                                        "onUpdate:value": ($event: any) => ((item.speaker) = $event),
                                        onKeydown: _withKeys(($event: any) => (updataDotting(2, item)), ["enter"]),
                                        onBlur: ($event: any) => (updataDotting(2, item)),
                                        placeholder: "请输入副标题",
                                        size: "small",
                                        style: {"width":"50%"}
                                      }, null, 8, ["value", "onUpdate:value", "onKeydown", "onBlur"]))
                                ])
                              ])
                            ], 8, _hoisted_15),
                            _createElementVNode("div", _hoisted_23, [
                              _createVNode(_component_svg_icon, {
                                "icon-class": "drag_icon",
                                class: "mover"
                              })
                            ])
                          ], 2))
                        }), 128))
                      ]),
                      _: 1
                    }, 16, ["list", "onDrop"])
                  ])
                ]))
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createTextVNode(" 禁用快进 "),
              _createVNode(_unref(aSwitch), {
                onChange: modifyConfig,
                checked: form.value.showForward,
                "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((form.value.showForward) = $event)),
                size: "small",
                class: "list_set_but_sw"
              }, null, 8, ["checked"])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_a_button, {
                onClick: openFullScreen,
                class: "black_btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 全屏 ")
                ]),
                _: 1
              }),
              _createVNode(_unref(aDropdown), {
                placement: "topCenter",
                trigger: ['click'],
                visible: visible.value,
                "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((visible).value = $event))
              }, {
                overlay: _withCtx(() => [
                  _createVNode(_unref(aMenu), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(aMenuItem), null, {
                        default: _withCtx(() => [
                          _createTextVNode(" 时间"),
                          _createVNode(_unref(aSwitch), {
                            onChange: modifyConfig,
                            checked: form.value.showDate,
                            "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((form.value.showDate) = $event)),
                            size: "small"
                          }, null, 8, ["checked"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(aMenuItem), null, {
                        default: _withCtx(() => [
                          _createTextVNode(" 封面"),
                          _createVNode(_unref(aSwitch), {
                            onChange: modifyConfig,
                            checked: form.value.showCover,
                            "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((form.value.showCover) = $event)),
                            size: "small"
                          }, null, 8, ["checked"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(aMenuItem), null, {
                        default: _withCtx(() => [
                          _createTextVNode(" 顺序号 "),
                          _createVNode(_unref(aSwitch), {
                            onChange: modifyConfig,
                            checked: form.value.showOrder,
                            "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((form.value.showOrder) = $event)),
                            size: "small"
                          }, null, 8, ["checked"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(aMenuItem), null, {
                        default: _withCtx(() => [
                          _createTextVNode(" 观看量 "),
                          _createVNode(_unref(aSwitch), {
                            onChange: modifyConfig,
                            checked: form.value.showNum,
                            "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((form.value.showNum) = $event)),
                            size: "small"
                          }, null, 8, ["checked"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_button, { class: "set_btn" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_svg_icon, { "icon-class": "media_moreset" }),
                      _createTextVNode(" 更多设置 ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_component_a_button, {
                onClick: emptyDot,
                class: "set_btn"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "media_clear" }),
                  _createTextVNode(" 清空打点 ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createVNode(_unref(aTimePicker), {
            value: timeValue.value,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((timeValue).value = $event)),
            valueFormat: "HH:mm:ss",
            onOpenChange: updataVideoTime
          }, null, 8, ["value"]),
          _createVNode(_unref(aTooltip), { placement: "bottom" }, {
            title: _withCtx(() => [
              _createTextVNode(" 撤回 / 快捷键 Ctrl+z ")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "link",
                class: "set_icon set_icon_left",
                onClick: onUndo,
                disabled: forwardList.value.length === 0,
                style: _normalizeStyle({
                opacity: forwardList.value.length === 0 ? 0.3 : 1,
              })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "media_withdraw" })
                ]),
                _: 1
              }, 8, ["disabled", "style"])
            ]),
            _: 1
          }),
          _createVNode(_unref(aTooltip), { placement: "bottom" }, {
            title: _withCtx(() => [
              _createTextVNode(" 恢复 / 快捷键 Ctrl+y ")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "link",
                class: "set_icon",
                onClick: onBack,
                disabled: backList.value.length === 0,
                style: _normalizeStyle({
                opacity: backList.value.length === 0 ? 0.3 : 1,
              })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "media_recall" })
                ]),
                _: 1
              }, 8, ["disabled", "style"])
            ]),
            _: 1
          }),
          _createVNode(_unref(aTooltip), { placement: "bottom" }, {
            title: _withCtx(() => [
              _createTextVNode(" 打点 / 快捷键 d ")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "link",
                class: "set_icon",
                onClick: videoManage,
                disabled: !_unref(disDot),
                style: _normalizeStyle({
                opacity: !_unref(disDot) ? 0.3 : 1,
              })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "media_frame" })
                ]),
                _: 1
              }, 8, ["disabled", "style"])
            ]),
            _: 1
          }),
          _createVNode(_unref(aTooltip), { placement: "bottom" }, {
            title: _withCtx(() => [
              _createTextVNode(" 删除 / 快捷键 delete ")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "link",
                class: "set_icon",
                onClick: deleteFrame,
                disabled: !clickFrame.value,
                style: _normalizeStyle({
                opacity: !clickFrame.value ? 0.3 : 1,
              })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "media_del" })
                ]),
                _: 1
              }, 8, ["disabled", "style"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, _toDisplayString(currentTime.value) + " - " + _toDisplayString(duration.value), 1),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_unref(aTooltip), { placement: "bottom" }, {
              title: _withCtx(() => [
                _createTextVNode(" 后退1秒 / 快捷键 left ")
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(StepBackwardOutlined), {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (clickSchedule(0)))
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(aTooltip), { placement: "bottom" }, {
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(!paused.value ? '播放' : '暂停') + " / 快捷键空格 ", 1)
              ]),
              default: _withCtx(() => [
                (!paused.value)
                  ? (_openBlock(), _createBlock(_unref(CaretRightOutlined), {
                      key: 0,
                      onClick: clickPlay
                    }))
                  : _createCommentVNode("", true),
                _createTextVNode(),
                (paused.value)
                  ? (_openBlock(), _createBlock(_unref(PauseOutlined), {
                      key: 1,
                      onClick: clickPlay
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_unref(aTooltip), { placement: "bottom" }, {
              title: _withCtx(() => [
                _createTextVNode(" 前进1秒 / 快捷键 right ")
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(StepForwardOutlined), {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (clickSchedule(1)))
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createTextVNode(" 16:9 "),
            _createVNode(_unref(aTooltip), { placement: "bottom" }, {
              title: _withCtx(() => [
                _createTextVNode(" 全屏 / 快捷键 F11 ")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, {
                  "icon-class": "media_all",
                  class: "icon",
                  onClick: clickFullScreen
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_unref(aTooltip), { placement: "bottom" }, {
            title: _withCtx(() => [
              _createTextVNode(" 缩小 / 快捷键 - ")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "link",
                class: "set_icon",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (clickZoomChange(1))),
                style: _normalizeStyle({
                pointerEvents: _unref(maxFrameOfMaterial) === 0 || _unref(frameWidth) === _unref(minFrameWidth) ? 'none' : 'auto',
                opacity: _unref(maxFrameOfMaterial) === 0 || _unref(frameWidth) === _unref(minFrameWidth) ? 0.3 : 1,
              })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "media_small" })
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          }),
          _createVNode(_unref(aTooltip), { placement: "bottom" }, {
            title: _withCtx(() => [
              _createTextVNode(" 放大 / 快捷键 + ")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "link",
                class: "set_icon",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (clickZoomChange(2))),
                style: _normalizeStyle({
                pointerEvents: gridWidth.value >= _unref(maxVideoUrlWidth) ? 'none' : 'auto',
                opacity: gridWidth.value >= _unref(maxVideoUrlWidth) ? 0.3 : 1,
              })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "media_large" })
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          }),
          _createVNode(_unref(aTooltip), { placement: "bottomRight" }, {
            title: _withCtx(() => [
              _createTextVNode(" 适中 / 快捷键 r ")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "link",
                class: "set_icon",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (clickZoomChange(3)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "media_refresh" })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", {
        ref_key: "frameVideoRef",
        ref: frameVideoRef,
        class: "updata_time",
        style: _normalizeStyle({ width: _unref(timeLine_width) + 'px' })
      }, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", {
            class: "timescale",
            style: _normalizeStyle({ width: gridWidth.value <= _unref(timeLine_width) - 30 ? _unref(timeLine_width) - 30 + 'px' : _unref(timescale_width) - 30 + 'px' }),
            onMousedown: clickUpdataTime
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gridBufferList), (grid, index) => {
              return (_openBlock(), _createBlock(Grid, {
                key: index,
                frame: grid.frame,
                width: grid.width,
                showNumber: grid.showNumber
              }, null, 8, ["frame", "width", "showNumber"]))
            }), 128))
          ], 36),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(route).query.title), 1),
            _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(route).query.duration), 1)
          ]),
          _createElementVNode("div", {
            ref_key: "frameManageRef",
            ref: frameManageRef,
            class: "video_line",
            style: _normalizeStyle({ width: gridWidth.value <= _unref(timeLine_width) - 30 ? _unref(timeLine_width) - 30 + 'px' : _unref(timescale_width) - 30 + 'px' })
          }, [
            _createVNode(VideoItem, {
              width: gridWidth.value,
              list: viderUrlList.value
            }, null, 8, ["width", "list"])
          ], 4),
          _withDirectives(_createElementVNode("div", {
            class: "progress",
            id: "move_icon",
            onMousedown: _withModifiers(timeDragMove, ["stop"])
          }, _hoisted_42, 40, _hoisted_39), [
            [_vShow, move.show]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(positionArr.value, (i, j) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["manage", { manage_click: showclickFrame.value[i] }]),
              onClick: ($event: any) => (clickManage(i)),
              key: j,
              style: _normalizeStyle({ left: i + 'px' })
            }, _hoisted_46, 14, _hoisted_43))
          }), 128))
        ])
      ], 4)
    ]),
    _createVNode(CDelModal, {
      visible: delVisible.value,
      centered: "",
      close: () => (delVisible.value = false),
      ok: emptyDot
    }, {
      title: _withCtx(() => [
        _createTextVNode("此操作将清空打点视频，是否继续？")
      ]),
      _: 1
    }, 8, ["visible", "close"]),
    _createVNode(_unref(aModal), {
      visible: modalLeave.value,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((modalLeave).value = $event)),
      centered: "",
      title: "提示",
      onOk: leaveView,
      onCancel: noLeaveView
    }, {
      default: _withCtx(() => [
        _hoisted_47
      ]),
      _: 1
    }, 8, ["visible"])
  ], 512))
}
}

})